import React from "react";

function Quality() {
  return (
    <section id="quality" className="section-padding">
      <div className="container text-center">
        <h2 className="fw-bold mb-4">Quality & Compliance</h2>

        <p className="text-muted mb-5">
          Every product undergoes stringent testing and complies with WHO-GMP
          and institutional healthcare regulations.
        </p>

        <div className="row">
          <div className="col-md-3"><h5>WHO-GMP Certified</h5></div>
          <div className="col-md-3"><h5>Batch Traceability</h5></div>
          <div className="col-md-3"><h5>Cold Chain Compliance</h5></div>
          <div className="col-md-3"><h5>Regulatory Approved</h5></div>
        </div>
      </div>
    </section>
  );
}

export default Quality;